import { useTranslation } from "react-i18next";
import { cx } from "../cx";
import { Percent } from "../format/Num";

/** A thin accent bar; `value` is a fraction 0..1. */
export function ProgressBar({
  value,
  size = "md",
  label,
  showPercent = false,
  className = "",
}: {
  value: number;
  size?: "sm" | "md";
  /** Accessible name; defaults to "Progress". */
  label?: string;
  showPercent?: boolean;
  className?: string;
}) {
  const { t } = useTranslation("components");
  const fraction = Math.min(1, Math.max(0, Number.isFinite(value) ? value : 0));
  return (
    <div className={cx("flex items-center gap-2.5", className)} data-component="ProgressBar">
      <div
        role="progressbar"
        aria-label={label ?? t("progress.label")}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(fraction * 100)}
        className={cx(
          "flex-1 overflow-hidden rounded-sm bg-surface",
          size === "sm" ? "h-1" : "h-1.5",
        )}
        style={{ outline: "1px solid var(--color-line-soft)" }}
      >
        <div className="h-full bg-accent" style={{ width: `${fraction * 100}%` }} />
      </div>
      {showPercent ? (
        <span className="font-mono text-label text-ink-2">
          <Percent value={fraction} />
        </span>
      ) : null}
    </div>
  );
}
